import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  "data-wizard-header": "",
  class: "-mx-4 -my-1.5 flex min-w-0 flex-1 items-center justify-between gap-4 bg-white px-6 py-3.5 md:px-7"
}
const _hoisted_2 = { class: "flex min-w-0 flex-col gap-0.5" }
const _hoisted_3 = {
  "aria-label": "Breadcrumb",
  class: "text-[13px] text-gray-500"
}
const _hoisted_4 = { class: "flex min-w-0 items-center gap-2.5" }
const _hoisted_5 = {
  "data-draft-pill": "",
  class: "flex-shrink-0 rounded-full bg-[#fef3c7] px-[9px] py-[3px] text-xs font-semibold text-[#92400e]"
}
const _hoisted_6 = { class: "flex flex-shrink-0 items-center gap-2" }
const _hoisted_7 = { class: "flex h-full bg-[#f6f7f9]" }
const _hoisted_8 = { class: "flex min-h-0 min-w-0 flex-1 flex-col" }
const _hoisted_9 = { class: "flex-1 overflow-y-auto px-6 py-9 md:px-10" }
const _hoisted_10 = {
  key: 0,
  "data-loading": "",
  class: "mx-auto max-w-[920px] text-sm text-gray-500"
}
const _hoisted_11 = {
  key: 1,
  "data-load-error": "",
  class: "mx-auto flex max-w-[920px] flex-col gap-3"
}
const _hoisted_12 = { class: "m-0 rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800" }
const _hoisted_13 = {
  key: 2,
  class: "mx-auto max-w-[920px]"
}
const _hoisted_14 = { class: "flex flex-col gap-1.5 pb-7" }
const _hoisted_15 = {
  "data-eyebrow": "",
  class: "m-0 text-[13px] font-semibold text-gray-500"
}
const _hoisted_16 = {
  "data-step-question": "",
  class: "m-0 text-2xl font-bold tracking-[-0.02em] text-gray-900"
}
const _hoisted_17 = {
  key: 0,
  class: "m-0 mt-1 max-w-2xl text-sm leading-relaxed text-gray-600"
}
const _hoisted_18 = {
  key: 0,
  "data-wizard-errors": "",
  class: "mb-6 list-none rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800"
}
const _hoisted_19 = { "data-step": "" }
const _hoisted_20 = {
  "data-wizard-footer": "",
  class: "border-t border-gray-200 bg-white px-6 py-3.5 md:px-12"
}
const _hoisted_21 = {
  key: 0,
  "data-created-footer": "",
  class: "flex items-center gap-4"
}

import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardConfirmModal from '@/components/neue/wizard/WizardConfirmModal.vue'
import WizardNav from '@/components/neue/wizard/WizardNav.vue'
import WizardRail from '@/components/neue/wizard/WizardRail.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import { useAgentWizard } from '@/composables/useAgentWizard'
import { useConfirm } from '@/composables/useConfirm'
import { provideWizard } from '@/composables/useWizardContext'
import {
  AGENT_STEP_KEYS,
  STEP_AGENT_TYPES,
  stepHeading,
  stepSubtitle,
  STORE_STEP_KEYS
} from '@/config/agentWizardSteps'
import { agentRowKey, railRows, setupRows } from '@/helpers/agentWizardSummary'
import { mapTypeIncludingInactive } from '@/store/mappers'
import AgentStepAbout from '@/view/ai/agentWizard/steps/AgentStepAbout.vue'
import AgentStepCarts from '@/view/ai/agentWizard/steps/AgentStepCarts.vue'
import AgentStepReview from '@/view/ai/agentWizard/steps/AgentStepReview.vue'
import AgentStepReviews from '@/view/ai/agentWizard/steps/AgentStepReviews.vue'
import AgentStepUpsell from '@/view/ai/agentWizard/steps/AgentStepUpsell.vue'
import AgentStepVoice from '@/view/ai/agentWizard/steps/AgentStepVoice.vue'
import AgentStepWinback from '@/view/ai/agentWizard/steps/AgentStepWinback.vue'

const ENTER_OWNERS = 'textarea, button, a, [role="button"], [role="listbox"], select'


export default {
  __name: 'AgentWizard',
  setup(__props, { expose: __expose }) {

const router = useRouter()

const wizard = useAgentWizard()
provideWizard(wizard)

const stepKey = computed(() => wizard.stepKey.value)
const onReview = computed(() => stepKey.value === 'review')
const subStoreName = computed(
  () => wizard.stores.value.find(store => String(store.id) === wizard.storeKey.value)?.store_name
)

// The agents this setup created, as they are now in the store.
const createdAgents = computed(() => {
  const ids = new Set(wizard.createdAgentIds.value)
  return mapTypeIncludingInactive('agent').filter(agent => ids.has(String(agent.id)))
})
const testingCount = computed(() => createdAgents.value.filter(agent => agent.attributes?.test_mode).length)

const copyCtx = computed(() => ({
  storeName: subStoreName.value || wizard.ctx.storeName,
  storeCount: wizard.ctx.storeCount,
  subStep: Boolean(wizard.storeKey.value),
  created: wizard.created.value,
  testingCount: testingCount.value
}))
const heading = computed(() => stepHeading(stepKey.value, wizard.data, copyCtx.value))
const subtitle = computed(() => stepSubtitle(stepKey.value, wizard.data, copyCtx.value))

const nextRow = computed(() => wizard.rows.value[wizard.rows.value.indexOf(wizard.step.value) + 1])
const nothingToCreate = computed(() => setupRows(wizard.data, wizard.stores.value, wizard.existing.value).length === 0)
const reviewDone = computed(() => wizard.created.value || nothingToCreate.value)
const primaryLabel = computed(() => {
  if (onReview.value) return reviewDone.value ? 'Done' : 'Create agents'
  return nextRow.value?.key === 'review' ? 'Review' : `Continue to ${nextRow.value?.label ?? 'Review'}`
})
const eyebrow = computed(() =>
  onReview.value
    ? 'Review'
    : `Step ${wizard.step.value.index + 1} of ${wizard.steps.value.length} · ${wizard.step.value.label}`
)

const railOpen = ref(false)
const railButtonLabel = computed(() =>
  onReview.value ? 'Setup' : `Step ${wizard.step.value.index + 1} of ${wizard.steps.value.length}`
)

const playbookStoreIds = computed(
  () =>
    new Map(
      mapTypeIncludingInactive('agent_playbook').map(playbook => [
        String(playbook.id),
        playbook.attributes?.belongs_to_id
      ])
    )
)
const stepKeyForAgent = agent => AGENT_STEP_KEYS.find(key => STEP_AGENT_TYPES[key] === agent.attributes?.type)

// Rail row key to created agent id. A store agent also answers for its step's shared row,
// whose store choices are pruned once the agents exist.
const agentIdsByRow = computed(() => {
  const ids = new Map()
  createdAgents.value.forEach(agent => {
    const key = stepKeyForAgent(agent)
    if (!key) return
    const id = String(agent.id)
    if (!STORE_STEP_KEYS.includes(key)) return ids.set(key, id)
    const storeId = playbookStoreIds.value.get(String(agent.relationships?.agent_playbook?.data?.id))
    if (storeId !== null && storeId !== undefined) ids.set(agentRowKey(key, String(storeId)), id)
    if (!ids.has(key)) ids.set(key, id)
  })
  return ids
})

const rail = computed(() =>
  railRows(wizard.rows.value, wizard.data, { key: stepKey.value, storeId: wizard.storeKey.value }, wizard.ctx, {
    created: wizard.created.value,
    agentIdsByRow: agentIdsByRow.value
  })
)

const jump = key => {
  const row = rail.value.find(candidate => candidate.key === key)
  if (!row) return
  wizard.go(row.stepKey, row.storeId)
  railOpen.value = false
}

const { state: confirmState, ask, confirm: confirmYes, cancel: confirmNo } = useConfirm()

const startOver = async () => {
  const sure = await ask({
    title: 'Start over?',
    message: wizard.created.value
      ? 'The setup form is cleared. Agents already created are kept.'
      : 'Everything entered here is cleared. Nothing has been saved yet.',
    confirmLabel: 'Start over',
    danger: true
  })
  if (sure) wizard.reset()
}

// Leaving after creation forgets the draft, so the next visit starts a new setup instead of this review.
const leave = () => {
  if (wizard.created.value) wizard.finish()
  return router.push('/ai/agents')
}

const advance = () => {
  if (!onReview.value) return wizard.next()
  if (reviewDone.value) return leave()
  if (!wizard.saving.value) wizard.submit()
}

// After creation the footer only goes live or leaves; it has no step to advance to.
const reviewStep = ref(null)
const goingLive = ref(false)
const anyTesting = computed(() => testingCount.value > 0)

const finishCreated = async () => {
  if (!anyTesting.value) return leave()
  if (goingLive.value) return
  goingLive.value = true
  try {
    await reviewStep.value?.goLiveAll()
  } finally {
    goingLive.value = false
  }
}

const onKeydown = event => {
  if (wizard.created.value) return
  if (event.key !== 'Enter' || event.defaultPrevented) return
  if (event.target?.closest?.(ENTER_OWNERS)) return
  event.preventDefault()
  advance()
}

onMounted(() => window.addEventListener('keydown', onKeydown))
onBeforeUnmount(() => window.removeEventListener('keydown', onKeydown))

__expose({ wizard })

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SecondaryNav, { "full-width": "" }, {
    top: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("nav", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/ai/agents",
              class: "hover:text-gray-900"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("AI Agents", -1)
              ]))]),
              _: 1
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", {
              "aria-hidden": "true",
              class: "mx-1"
            }, "/", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Set up", -1))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", {
              "data-top": "",
              class: "m-0 truncate pb-0.5 text-[22px] font-bold leading-snug tracking-[-0.02em] text-gray-900"
            }, " AI agent setup ", -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(wizard).created.value ? 'Agents created · in testing' : 'Draft · not saved'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(WizardButton, {
            class: "min-[1100px]:hidden",
            "aria-expanded": railOpen.value,
            onClick: _cache[0] || (_cache[0] = $event => (railOpen.value = !railOpen.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(railButtonLabel.value), 1)
            ]),
            _: 1
          }, 8, ["aria-expanded"]),
          _createVNode(WizardButton, {
            onClick: _cache[1] || (_cache[1] = $event => (_unref(router).push('/ai/agents')))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Close", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_unref(wizard).loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Loading your stores... "))
              : (_unref(wizard).loadFailed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(wizard).errors.value[0]), 1),
                    _createElementVNode("div", null, [
                      _createVNode(WizardButton, {
                        variant: "primary",
                        onClick: _unref(wizard).retry
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("Retry", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(eyebrow.value), 1),
                      _createElementVNode("h2", _hoisted_16, _toDisplayString(heading.value), 1),
                      (subtitle.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(subtitle.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_unref(wizard).errors.value.length && !onReview.value)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).errors.value, (message) => {
                            return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      (stepKey.value === 'voice')
                        ? (_openBlock(), _createBlock(AgentStepVoice, { key: 0 }))
                        : (stepKey.value === 'about')
                          ? (_openBlock(), _createBlock(AgentStepAbout, { key: 1 }))
                          : (stepKey.value === 'winback')
                            ? (_openBlock(), _createBlock(AgentStepWinback, { key: 2 }))
                            : (stepKey.value === 'reviews')
                              ? (_openBlock(), _createBlock(AgentStepReviews, { key: 3 }))
                              : (stepKey.value === 'carts')
                                ? (_openBlock(), _createBlock(AgentStepCarts, {
                                    key: 4,
                                    "store-id": _unref(wizard).storeKey.value ?? null
                                  }, null, 8, ["store-id"]))
                                : (stepKey.value === 'upsell')
                                  ? (_openBlock(), _createBlock(AgentStepUpsell, {
                                      key: 5,
                                      "store-id": _unref(wizard).storeKey.value ?? null
                                    }, null, 8, ["store-id"]))
                                  : (_openBlock(), _createBlock(AgentStepReview, {
                                      key: 6,
                                      ref_key: "reviewStep",
                                      ref: reviewStep
                                    }, null, 512))
                    ])
                  ]))
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_unref(wizard).created.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(WizardButton, { onClick: startOver }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("← Start over", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  _createVNode(WizardButton, {
                    variant: "primary",
                    disabled: _unref(wizard).loading.value,
                    loading: goingLive.value,
                    onClick: finishCreated
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(anyTesting.value ? 'Go live with all' : 'Done'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]))
              : (!_unref(wizard).loadFailed.value)
                ? (_openBlock(), _createBlock(WizardNav, {
                    key: 1,
                    "show-back": _unref(wizard).step.value.index > 0,
                    "primary-label": primaryLabel.value,
                    "primary-enabled": !_unref(wizard).loading.value && (onReview.value || _unref(wizard).valid.value),
                    loading: _unref(wizard).saving.value,
                    arrow: !onReview.value,
                    onBack: _unref(wizard).back,
                    onPrimary: advance
                  }, null, 8, ["show-back", "primary-label", "primary-enabled", "loading", "arrow", "onBack"]))
                : _createCommentVNode("", true)
          ])
        ]),
        (railOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-30 bg-black/20 min-[1100px]:hidden",
              onClick: _cache[2] || (_cache[2] = $event => (railOpen.value = false))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          "data-so-far": "",
          class: _normalizeClass(["w-80 flex-shrink-0 border-l border-gray-200 bg-white min-[1100px]:static min-[1100px]:block min-[1100px]:shadow-none", railOpen.value ? 'fixed inset-y-0 right-0 z-40 overflow-y-auto shadow-xl' : 'hidden'])
        }, [
          _createVNode(WizardRail, {
            rows: rail.value,
            title: "Setup",
            onJump: jump
          }, {
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("p", { class: "m-0 text-[13px] text-gray-500" }, "Nothing is saved until you create your agents.", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "mt-2 text-[13px] text-gray-600 underline hover:text-gray-900",
                onClick: startOver
              }, " Start over ")
            ]),
            _: 1
          }, 8, ["rows"])
        ], 2)
      ]),
      _createVNode(WizardConfirmModal, _mergeProps(_unref(confirmState), {
        onConfirm: _unref(confirmYes),
        onCancel: _unref(confirmNo)
      }), null, 16, ["onConfirm", "onCancel"])
    ]),
    _: 1
  }))
}
}

}